module.exports = __webpack_public_path__ + "img/output-onlinegiftools (27).d2d4fded.gif";